import { createSelector } from "reselect";
import get from "lodash/get";

// Selector factory: memoized per (componentKey, instanceId, path)
export const makeSelectComponentProp = (componentKey, instanceId, path) =>
	createSelector(
		// Input: slice for this component + instance
		state => state?.componentState?.[componentKey]?.[instanceId] || {},

		// Output: the nested value at the given path
		slice => get(slice, path)
	);
